function isMobile()
{ // Checks if we are in mobile viewport
	return getComputedStyle(document.documentElement)
		.getPropertyValue('--is-mobile-nav')
		.trim() === 'true';
}

class NavDropdownMenu
{

	constructor(headerSelector)
	{
		this.header = document.querySelector(headerSelector);
		this.navExpanded = false;

		if (this.header) {
			this.init();
		}
	}

	init()
	{
		this.setSubmenuTabIndex('-1');
		this.bindEvents();
	}

	setSubmenuTabIndex(value)
	{
		this.header.querySelectorAll('.nbm__submenu-item a').forEach(link => {
			link.setAttribute('tabindex', value);
		});
	}

	toggleSubmenu(e) {
		const btn = e.currentTarget;
		const isExpanded = btn.getAttribute('aria-expanded') === 'true';

		if (isExpanded)
		{
			this.headerSubmenuCloseAll();
		}
		else
		{
			this.headerSubmenuOpen(e);
		}
	}

	headerSubmenuOpen(e)
	{
		e.stopPropagation();

		const button = e.currentTarget;
		const buttonParent = button.closest('.nbm__item');

		this.headerSubmenuCloseAll(buttonParent);

		this.setSubmenuTabIndex('-1');

		button.setAttribute('aria-expanded', 'true');

		buttonParent.classList.add('nbm__item--open');
		buttonParent.querySelectorAll('.nbm__submenu-item a').forEach(link => {
			link.setAttribute('tabindex', '0');
		});
	}

	headerSubmenuCloseAll(exceptionItem = null)
	{
		this.header.querySelectorAll('.nbm__item--has-children').forEach(item => {

			if (item === exceptionItem) return;

			const button = item.querySelector('.nbm__submenu-btn');
			button.setAttribute('aria-expanded', 'false');

			item.classList.remove('nbm__item--open');

			item.querySelectorAll('.nbm__submenu-item a').forEach(link => {
				link.setAttribute('tabindex', '-1');
			});
		});
	}

	handleMobileMenuExpansion(forceState = null)
	{
		if (!isMobile()) { return; }

		const navBarMenu = this.header.querySelector('.nav-bar__menu-container');
		const navBarButton = this.header.querySelector('.nav-bar__menu-btn');
		const navBarButtonText = navBarButton.querySelector('.nav-bar__menu-btn-text');

		if (!navBarMenu || !navBarButton || !navBarButtonText) { return; }

		// Toggle state
		if (typeof forceState === 'boolean') {
			this.navExpanded = forceState; // Forced (i.e. Esc button press)
		} else {
			this.navExpanded = !this.navExpanded; // Standard toggle
		}

		// Prevents menu positioning when scrollbars disappear
		const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
		if (this.navExpanded)
		{
			document.body.style.paddingRight = `${scrollbarWidth}px`;
		} else {
			document.body.style.paddingRight = '';
		}

		document.body.classList.toggle('mobile-menu-open', this.navExpanded);
		navBarMenu.classList.toggle('nav-bar__menu-container--active', this.navExpanded);
		navBarButton.setAttribute('aria-expanded', this.navExpanded);
		navBarButton.classList.toggle('is-open', this.navExpanded);
		navBarButtonText.textContent = this.navExpanded ? 'Close' : 'Menu';
	}

	handleMobileSubMenuExpansion(e)
	{
		if (!isMobile()) { return; }

		const subMenuButton = e.currentTarget;
		const buttonParent = subMenuButton.closest('.nbm__item--has-children');
		const link = buttonParent.querySelector(':scope > a');

		// Toggle parent open/close class
		buttonParent.classList.toggle('nbm__item--open');

		// Toggle ARIA expanded state (for screen readers)
		const expandedState = subMenuButton.getAttribute('aria-expanded') === 'true';
		const newState = expandedState ? 'false' : 'true';

		subMenuButton.setAttribute('aria-expanded', newState);
		link.setAttribute('aria-expanded', newState);

		// Set tabindex based on open/close state
		const tabindexValue = newState === 'true' ? '0' : '-1';
		buttonParent.querySelectorAll('.nbm__submenu-item a').forEach(link => {
			link.setAttribute('tabindex', tabindexValue);
		});
	}

	bindEvents()
	{
		this.header.querySelectorAll('.nbm__submenu-btn').forEach(btn => {

			btn.addEventListener('touchstart', e => {
				e.preventDefault();
				e.stopPropagation();
				this.toggleSubmenu(e);
			}, { passive: false });

			btn.addEventListener('click', e => {
				e.preventDefault();
        e.stopPropagation();
        this.toggleSubmenu(e);
			});
		});

		document.querySelectorAll('.nbm__item > a, .nbm__item-parent > a').forEach(link => {
			link.addEventListener('focus', e => this.headerSubmenuCloseAll(e));
		});

		document.addEventListener('keyup', e => {
			if (e.key === 'Escape') {
				this.headerSubmenuCloseAll(e);
				this.handleMobileMenuExpansion(false);
			}
		});

		this.header.querySelectorAll('.nbm__item--has-children').forEach(item => {

			item.addEventListener('mouseenter', () => {

				if (isMobile()) { return; }

				const button = item.querySelector('.nbm__submenu-btn');

				button.setAttribute('aria-expanded', 'true');

				item.classList.add('nbm__item--open');

				item.querySelectorAll('.nbm__submenu-item a').forEach(link => {
					link.setAttribute('tabindex', '0');
				});

			});

			item.addEventListener('mouseleave', () => {

				if (isMobile()) { return; }

				const button = item.querySelector('.nbm__submenu-btn');

				button.setAttribute('aria-expanded', 'false');

				item.classList.remove('nbm__item--open');

				item.querySelectorAll('.nbm__submenu-item a').forEach(link => {
					link.setAttribute('tabindex', '-1');
				});

			});

    });

		this.header.querySelectorAll('.nav-bar__menu-btn').forEach(btn => {
			btn.addEventListener('click', () => this.handleMobileMenuExpansion());
		});

		this.header.querySelectorAll('.nbm__submenu-btn').forEach(btn => {
			//btn.addEventListener('click', e => this.handleMobileSubMenuExpansion(e));
		});
	}

}

document.addEventListener('DOMContentLoaded', () => {
	new NavDropdownMenu('header');
});